import { instance } from "libs/api";

import { ApiRoutesDeliveryPriority } from "../../constants";
import { ReorderDeliveryPriorityPayload } from "../../deliveryPriority.types";

export const requestReorderDeliveryPriority = async (
  body: ReorderDeliveryPriorityPayload
): Promise<void> => {
  return await instance.put(
    ApiRoutesDeliveryPriority.DeliveryPriority,
    body
  );
};
